import { createModule } from 'saga-slice';
import { fetchCurrencySagaFactory, updateCurrencySagaFactory } from './sagas';
import { initialState, CurrencyState } from './stateType';

const CurrencySlice = createModule({
  name: 'currency',
  initialState,
  reducers: {
    fetchCurrency: (state: CurrencyState) => {
      state.loading = true;
    },
    fetchCurrencySuccess: (state: CurrencyState, payload: object[]) => {
      state.loading = false;
      state.currency = payload;
      state.selectedFy = Object.keys(payload)[0];
    },
    fetchCurrencyError: (state: CurrencyState, payload: Error) => {
      state.loading = false;
      state.error = payload;
    },
    updateCurrency: (state: CurrencyState) => {
      state.loading = true;
    },
    updateCurrencySuccess: (state: CurrencyState, payload) => {
      state.loading = false;
      state.currency[payload.fy] = payload.factors;
    },
    updateCurrencyError: (state: CurrencyState, payload: Error) => {
      state.loading = false;
      state.error = payload;
    },
    changeSelectedFy: (state: CurrencyState, payload: string) => {
      state.selectedFy = payload;
    },
  },
  sagas: (actions) => ({
    [actions.fetchCurrency]: fetchCurrencySagaFactory(actions),
    [actions.updateCurrency]: updateCurrencySagaFactory(actions),
  }),
});

export default CurrencySlice;
export const currencyActions = CurrencySlice.actions;
